import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, createElement } from 'react';
import { b as _extends, d as _objectDestructuringEmpty, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';
import InputAddon from '../InputAddon/InputAddon.js';

const SearchFieldWrapper = styled(Div).attrs(_ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return _objectSpread2({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, props);
})``;

const SearchField = ({
  onSearchChange,
  styles,
  placeholder
}) => {
  const [isOnFocus, setIsOnFocus] = useState(false);
  const theme = useTheme();
  const searchFieldStyles = styles || {
    root: {
      width: '100%',
      ml: `${theme.spacing.xlg}px`,
      mr: `${theme.spacing.xlg}px`
    },
    input: {
      height: '42px',
      border: 'none!important',
      boxShadow: 'none!important'
    }
  };
  const inputStyles = isOnFocus && searchFieldStyles !== null && searchFieldStyles !== void 0 && searchFieldStyles.inputFocus ? searchFieldStyles === null || searchFieldStyles === void 0 ? void 0 : searchFieldStyles.inputFocus : searchFieldStyles === null || searchFieldStyles === void 0 ? void 0 : searchFieldStyles.input;
  return /*#__PURE__*/createElement(SearchFieldWrapper, searchFieldStyles === null || searchFieldStyles === void 0 ? void 0 : searchFieldStyles.wrapper, /*#__PURE__*/createElement(TextInput, {
    startInputAddon: /*#__PURE__*/createElement(InputAddon, {
      position: "start"
    }, /*#__PURE__*/createElement(Icon, {
      glyph: icons.SEARCH,
      styles: {
        root: {
          color: theme.palette.black[60],
          mt: '-2px'
        }
      }
    })),
    placeholder: placeholder,
    onChange: e => onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(e.target.value),
    onFocus: () => setIsOnFocus(true),
    onBlur: () => setIsOnFocus(false),
    styles: {
      root: _objectSpread2({}, searchFieldStyles === null || searchFieldStyles === void 0 ? void 0 : searchFieldStyles.root),
      input: _objectSpread2({}, inputStyles)
    }
  }));
};

export default SearchField;
